const EMPTY_STATE_CLASS_PATTERN = /^[A-Za-z0-9_-]+$/;

const escapeHtml = (value) => String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const normalizeClassNames = (className) => String(className || '')
    .split(/\s+/)
    .map((name) => name.trim())
    .filter((name) => name && EMPTY_STATE_CLASS_PATTERN.test(name));

export function emptyStateHtml({
    title = '',
    text = '',
    actionHtml = '',
    className = '',
    compact = false,
} = {}) {
    const classes = [
        'app-empty-state',
        compact ? 'app-empty-state--compact' : '',
        ...normalizeClassNames(className),
    ].filter(Boolean);

    return `
        <div class="${classes.join(' ')}">
            ${title ? `<div class="app-empty-state__title">${escapeHtml(title)}</div>` : ''}
            ${text ? `<div class="app-empty-state__text">${escapeHtml(text)}</div>` : ''}
            ${actionHtml ? `<div class="app-empty-state__actions">${actionHtml}</div>` : ''}
        </div>
    `;
}

export function loadingStateHtml({
    title = '',
    text = '',
    className = '',
    compact = false,
} = {}) {
    const classes = [
        'app-loading-state',
        compact ? 'app-loading-state--compact' : '',
        ...normalizeClassNames(className),
    ].filter(Boolean);

    return `
        <div class="${classes.join(' ')}" role="status" aria-live="polite" aria-busy="true">
            <span class="app-loading-state__spinner" aria-hidden="true"></span>
            ${title ? `<div class="app-loading-state__title">${escapeHtml(title)}</div>` : ''}
            ${text ? `<div class="app-loading-state__text">${escapeHtml(text)}</div>` : ''}
        </div>
    `;
}
